import { useRouteError, Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';
import { Button } from './ui/Button';

export default function ErrorBoundary() {
  const error = useRouteError() as Error;

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="max-w-2xl w-full">
        <CardHeader>
          <CardTitle className="text-red-500">Ups! Coś poszło nie tak</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <p className="text-sm font-medium text-red-800">Szczegóły błędu:</p>
            <p className="text-sm text-red-600 mt-2 font-mono">
              {error?.message || 'Nieznany błąd'}
            </p>
          </div>

          {import.meta.env.DEV && error?.stack && (
            <details className="text-xs">
              <summary className="cursor-pointer text-muted-foreground hover:text-foreground">
                Stack trace (tylko w dev mode)
              </summary>
              <pre className="mt-2 p-4 bg-gray-100 rounded-md overflow-auto text-xs">
                {error.stack}
              </pre>
            </details>
          )}

          <div className="flex gap-2">
            <Button onClick={() => window.location.reload()}>Odśwież stronę</Button>
            <Link to="/bookings">
              <Button variant="outline">Powrót do strony głównej</Button>
            </Link>
          </div>

          <p className="text-sm text-muted-foreground">
            Jeśli problem się powtarza, skontaktuj się z administratorem.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
